"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    container: _defineProperty({
      borderBottom: "1px solid " + theme.palette.grey[300],
      borderTop: "1px solid " + theme.palette.grey[300],
      padding: theme.spacing(2, 0, 1, 0)
    }, theme.breakpoints.up("md"), {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    }),
    headline: _defineProperty({
      margin: theme.spacing(0, 0, 2, 0)
    }, theme.breakpoints.up("md"), {
      margin: theme.spacing(0, 4, 0, 0)
    }),
    list: _defineProperty({}, theme.breakpoints.up("md"), {
      display: "flex",
      flex: "1 0 50%",
      flexWrap: "wrap",
      justifyContent: "flex-end"
    })
  };
});
var _default = styles;
exports.default = _default;